import type { ReactNode } from 'react'

interface ErrorMessageProps {
  message: string
  action?: ReactNode
}

export function ErrorMessage({ message, action }: ErrorMessageProps) {
  return (
    <div
      role='alert'
      className='bg-error-50 text-error-700 px-4 py-3 rounded-lg text-sm border border-error-200 animate-fade-in'
    >
      <div className='flex items-start space-x-2'>
        <svg
          className='mt-0.5 h-4 w-4 shrink-0 text-error-500'
          fill='currentColor'
          viewBox='0 0 20 20'
        >
          <path
            fillRule='evenodd'
            d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z'
            clipRule='evenodd'
          />
        </svg>
        <div className='min-w-0'>
          <p>{message}</p>
          {action ? <div className='mt-2'>{action}</div> : null}
        </div>
      </div>
    </div>
  )
}
